import React from "react";
import { Spinner } from "reactstrap";
import SchemaOptimizerPipelineSteps, {
	processingDetailMessage,
	processingTitle,
} from "./SchemaOptimizerPipelineSteps";
import { shorthandUrl } from "./schemaOptimizerUtils";

export default function SchemaOptimizerProcessing({
	status,
	progressMessage,
	useBatchApi,
	pageUrl,
}) {
	const title = processingTitle(status, progressMessage);
	const detail = processingDetailMessage(status, progressMessage);
	const urlLabel = pageUrl ? shorthandUrl(pageUrl, 72) : null;

	return (
		<div className="schema-optimizer__processing card border shadow-sm">
			<div className="card-body schema-optimizer__processing-body">
				<div className="schema-optimizer__processing-main text-center">
					<Spinner color="primary" className="schema-optimizer__processing-spinner mb-3" />
					<p className="schema-optimizer__processing-title mb-1">{title}</p>
					{detail && (
						<p className="schema-optimizer__processing-detail text-muted small mb-2">
							{detail}
						</p>
					)}
					{urlLabel && (
						<p className="schema-optimizer__processing-url text-muted small mb-2" title={pageUrl}>
							{urlLabel}
						</p>
					)}
					<p className="text-muted small mb-0">
						{useBatchApi
							? "Batch processing may take a few minutes."
							: "Usually completes in under a minute."}
					</p>
				</div>
				<SchemaOptimizerPipelineSteps
					status={status}
					progressMessage={progressMessage}
					useBatchApi={useBatchApi}
				/>
			</div>
		</div>
	);
}
